import { message } from 'antd';
import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';
import { useTranslation } from 'react-i18next';

export default function useDormitoryLeaveForm() {
  const [t] = useTranslation(['common']);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const submit = useCallback(async (payload: DormitoryLeaveEntity) => {
    try {
      setLoading(true);
      setError('');
      const response = (await DormitoryLegacyHttp.leave(payload)).data;
      if (response.type === 'SUCCESS') {
        message.success(t('common:messages.request-success-submit'));
      }
      return response;
    }
    catch (e: any) {
      const msg = parseError(e);
      setError(msg);
      message.error(msg);
      throw new Error(msg);
    }
    finally {
      setLoading(false);
    }
  }, [t]);
  return { loading, error, submit };
}
